import type { SprayCalibration } from '../services/sprayService';

/**
 * calibrationValidity
 *
 * The "validity" rule for a calibration record. A calibration is valid when:
 *
 *   - it exists,
 *   - its status is 'active' (or absent — legacy records interpreted as
 *     active until Phase 5 lands the schema field),
 *   - it has an `attachmentKey` (the signed sign-off PDF, the audit anchor),
 *   - and at least one intensity row has an effective volume per tree or
 *     litres per hectare populated.
 *
 * Drives the "Awaiting signed document" pill on the calibration list and the
 * "Awaiting valid calibration" degradation on the machine-status badge.
 */
export function isValid(calibration: SprayCalibration | undefined): boolean {
  if (!calibration) return false;
  if (calibration.status === 'deleted') return false;
  if (!calibration.attachmentKey) return false;
  return calibration.intensityLevels.some(
    level => level.volumePerTree !== undefined || level.litresPerHectare !== undefined
  );
}
